<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.name"
          name="name"
          :counter="65"
          :label="`${$t('BOOKING.RESOURCES.NAME_IN_THE_APP')} *`"
          :error-messages="errors.name"
          :readonly="readonly"
          :rules="getRulesByName('name')"
          @input="updateValue('name', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text--secondary text-caption mt-1">
          {{ $t('ITEM.DESCRIPTION') }}
        </div>
        <v-card outlined>
          <ckeditor
            ref="editor"
            v-model="description"
            name="description"
            :editor="editor"
            :config="editorConfig"
            :style="editorStyle"
            :error-messages="errors.description"
            :readonly="readonly"
            @input="updateValue('description', $event)"
            @ready="onReady"
          >
          </ckeditor>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DecoupledDoc from '@ckeditor/ckeditor5-build-decoupled-document';
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty, maxLength } from '@/modules/_global/variables/rules';

export default {
  mixins: [formEditable],

  props: {
    locale: {
      type: String,
      default: 'en'
    },
    languageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {
        name: '',
        description: '',
        language_id: this.languageId
      },
      rules: {
        name: [notEmpty, maxLength(65)]
      },
      editor: DecoupledDoc,
      editorStyle: {
        minHeight: '300px'
      }
    };
  },

  computed: {
    editorConfig() {
      return {
        language: this.locale,
        isReadOnly: this.readonly,
        removePlugins: [
          'Image',
          'ImageCaption',
          'ImageStyle',
          'ImageToolbar',
          'ImageUpload',
          'Link',
          'MediaEmbed'
        ],
        toolbar: [
          'heading',
          '|',
          'fontfamily',
          'fontsize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'indent',
          'outdent',
          '|',
          'blockquote',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      };
    },

    description: {
      get() {
        return this.form.description || '';
      },
      set(v) {
        this.form.description = v;
      }
    }
  },

  methods: {
    onReady(editor) {
      editor.isReadOnly = this.readonly;
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    }
  }
};
</script>
